export default {
    "code": 0,
    "data": {
        "statusList": []
    },
    "message": "SUCCESS"
}